<app-main-layout>
  <app-client-form-page></app-client-form-page>
</app-main-layout>
